/**
 * @function
 * @arg {{ [key: string]: any }} obj - a plain object. If value is another object, key is concatenated to internal keys
 * @arg {string} prefix - used to add a prefix to keys
 * @return {string} - query params with '&' and without '?'
 */
const parse = (obj, prefix) => {
  const entries = Object.entries(obj);
  return entries
    .filter(([, value]) => Array.isArray(value) ? value.length > 0 : !!value)
    .map(([key, value]) => {
      const snakeCase = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
      const safeKey = prefix ? `${prefix}[${snakeCase}]` : snakeCase;

      if (typeof value === 'object' && !Array.isArray(value)) {
        return parse(value, safeKey);
      }
      
      const safeValue = Array.isArray(value) ? value.join(';') : value;
      return `${safeKey}=${safeValue}`;
    })
    .filter(query => !!query)
    .join('&');
};

/**
 * Converte parâmetros em query string (`chave=valor&chave2=valor2`).
 *
 * Aceita também uma query string **já serializada** e a devolve exatamente como
 * veio: o componente genérico `MasterDetail` chama
 * `resource.get({ query: 'page=1&per_page=10' })`. Sem esse atalho, o
 * `Object.entries(string)` iteraria **caractere a caractere** e montaria
 * `?0=p&1=a&2=g&...`, quebrando a paginação das telas.
 *
 * @arg {{ [key: string]: any }|string} params - objeto de parâmetros ou query string pronta
 * @arg {string} [prefix] - prefixo aplicado às chaves (uso interno/recursivo)
 * @return {string} - query params com '&' e sem '?'
 */
const objectToQueryParams = (params, prefix) => {
  if (typeof params === 'string') {
    return params;
  }

  if (!params || typeof params !== 'object') {
    return '';
  }

  return parse(params, prefix);
};

export default objectToQueryParams;
